// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'regenerator-runtime/runtime'
import Vue from 'vue'
import Intersect from './directives/intersect'
import resize from 'vue-resize-directive'
import PortalVue from 'portal-vue'

import { sync } from 'vuex-router-sync'
import Vuetify from 'vuetify'
import VueClipboard from 'vue-clipboard2'
import VueShortKey from 'vue-shortkey'
import 'normalize.css/normalize.css'
import '@mdi/font/css/materialdesignicons.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
// import 'typeface-saira/index.css'
// import 'typeface-lato/index.css'
import 'vuetify/dist/vuetify.min.css'
import './css/styles.css'
import './css/bootstrap/selection.scss'

import DebouncedResize from './directives/debouncedResize'
import NavTo from './directives/navTo'
import Draggable from './directives/draggable'
import themes from './config/themes.json'
import store from './store'
import router from './router'
import { init as initTracking } from './tracking'

// Import Partial Components
import App from './components/App'
import VHighlightJS from './directives/highlight'
import Targetable from './directives/targetable'

// Import Filters
import Ipv6toipv4 from '@/filters/ipv6toipv4'
import RelativeTime from '@/filters/relativeTime'
import AbbreviateAggregation from '@/filters/abbreviateAggregation'
import Pluralize from '@/filters/pluralize'

import Notifications from 'vue-notification'

Vue.config.productionTip = true

Vue.use(Notifications)
Vue.use(Vuetify, {
  theme: themes.dark,
  iconfont: 'md',
})
Vue.use(VHighlightJS)
Vue.use(Targetable)
Vue.use(VueClipboard)
Vue.use(VueShortKey)
Vue.use(PortalVue)

// Setup directives
Vue.directive('debounced-resize', DebouncedResize)
Vue.directive('nav-to', NavTo)
Vue.directive('resize', resize)
Vue.directive('intersect', Intersect)
Vue.directive('draggable', Draggable)

// Custom watchAll method for multiple props watching
Vue.prototype.$watchAllProps = function(props, callback) {
  props.forEach(prop => {
    // Pass the prop as the first argument to our callback
    this.$watch(prop, callback.bind(null, prop))
  })
}

// Here we sync the router with the store
sync(store, router)

// Register components globally
// For clarity the custom element name must be the component filename converted to hyphen case
// registerComponent('dashboard-page', DashboardPage)

// Register Filters globally
Vue.filter('ipv6toipv4', Ipv6toipv4)
Vue.filter('relativeTime', RelativeTime)
Vue.filter('abbreviateAggregation', AbbreviateAggregation)
Vue.filter('pluralize', Pluralize)

initTracking()

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  store,
  render(createElement) {
    return createElement(App)
  },
})

// function traceMethodCalls (obj) {
//   const handler = {
//     get (target, propKey, receiver) {
//       console.log('Proxy exec')
//       const origMethod = target[propKey]
//       console.log('Origmethod: ', origMethod)
//       return function (...args) {
//         const result = origMethod.apply(this, args)
//         console.log(propKey + JSON.stringify(args) + ' -> ' + JSON.stringify(result))
//         return result
//       }
//     }
//   }
//   return new Proxy(obj, handler)
// }

// vm.$store.getters = traceMethodCalls(vm.$store.getters)
// console.log(vm.$store.getters.apps())

window.vue = vm
export default vm
